import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { NbAutocompleteDirective, NbDialogService } from '@nebular/theme';
import { OfbizField } from '../ofbiz-form-model';
import { LookupFieldService } from './lookup-field.service';
import { Subject, Subscription } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

export interface LookupSelectedValue {
  field: string;
  value: string;
  description: string;
}

@Component({
  selector: 'ubs-lookup-field',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './lookup-field.component.html',
  styleUrls: ['./lookup-field.component.scss']
})
export class LookupFieldComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() formField: OfbizField;
  fieldName: string;
  endpoint: string;
  entityName: string;
  fieldFormName: string;
  searchFields: string;
  conditionFields: any[] = [];
  lookupOptionList: any[];

  lookupSelectedValueSubscription: Subscription;

  /**
   * 1. Emits the value of the field to the OfbizFormFieldComponent
   * 2. The OfbizFormFieldComponent patches the form control with the received value
   */
  @Output() setLookupField: EventEmitter<any> = new EventEmitter<any>();
  @Output() openLookupDialogEvent: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('input', { static: true }) input: ElementRef;
  // @ViewChild('autoControl', { read: NbAutocompleteDirective }) autoComplete: NbAutocompleteDirective<any>;

  // readonly results$ = this.ofbizFormService.result;
  public readonly results$ = this.lookupFieldService.result.pipe(
    map(rows => {
      const transformedItems: any[] = [];
      if (rows != undefined && rows != null) {
        rows.forEach((row: any[]) => {
          const transItem = {};
          const idItem = row[0];
          transItem["id"] = (Object.values(idItem))[0];
          const descItem1 = row[1];
          const descItem2 = row[2];
          transItem["description"] = (Object.values(descItem1))[0] || (Object.values(descItem2))[0];
          transformedItems.push(transItem);
        });
        console.log({ TrackItems: transformedItems });
        this.lookupOptionList = transformedItems;
      }
      /* if(this.autoComplete.isClosed){
        this.autoComplete.show();
      } */
      return transformedItems;
    }

    )
  );

  private readonly destroy$ = new Subject<void>();

  private readonly lookupSelected$ = this.lookupFieldService.getLookupSelectedValue()
    .pipe(
      takeUntil(this.destroy$),
      map(data => data))

  constructor(private lookupFieldService: LookupFieldService
  ) { }

  ngOnInit(): void {
    this.lookupSelected$.subscribe((data: LookupSelectedValue) => {
      console.log({ TrackLookupSelectedValue: data, formFieldName: this.formField.name });
      const lookupSelectedValue: LookupSelectedValue = data;
      console.log(lookupSelectedValue)
      const fieldName = lookupSelectedValue.field; // data["field"];
      const value = lookupSelectedValue.value; // data["value"];
      let description = lookupSelectedValue.description; // data["description"];
      if (description == undefined) {
        description = value;
      }
      if (fieldName != undefined) {
        this.setLookupField.emit(value);
        this.input.nativeElement.value = description;
        this.lookupFieldService.isSelected();
        console.log("It's done")
      } else {
        console.log("It's NOT done", fieldName, value, description)
      }
    })
    /* this.lookupSelectedValueSubscription = this.lookupFieldService.getLookupSelectedValue()
    .pipe(takeUntil(this.destroy$))
    .subscribe((data:any) => {
      if(data != null && data != undefined){
        console.log({TrackLookupSelectedValue:data,formFieldName:this.formField.name});
        let fieldName = data["field"];
        let value = data["value"];
        let description = data["description"];
        if(fieldName != undefined){
          this.setLookupField.emit(value);
          this.input.nativeElement.value = description;
          this.lookupFieldService.isSelected();
          console.log("It's done")
        }else{
          console.log("It's NOT done",fieldName,value,description)
        }
      }
    }); */
  }

  ngAfterViewInit(): void {
    // Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    // Add 'implements AfterViewInit' to the class.
    if (this.formField) {
      // console.log({IsClosed:this.autoComplete.isClosed});
      // console.log({"lookupField":this.formField});
      this.entityName = this.formField.lookupOptions.entityName || '';
      this.searchFields = this.lookupFieldService.convertListToString(this.formField.lookupOptions.targetParameterList);
      this.fieldFormName = this.formField.lookupOptions.fieldFormName;
      this.conditionFields = this.formField.lookupOptions?.conditionFields || [];
      this.fieldName = this.formField.name;
      // this.endpoint = this.formField["name"];
      if (this.formField.value) {
        // console.log({InitialValueLookup:"doing initial lookup"});
        // this.ofbizFormService.lookUp(this.formField.value,this.fieldName,this.entityName,this.searchFields,this.fieldFormName);
        this.lookupFieldService.doLookUp(this.formField.value, this.searchFields, this.entityName, this.fieldFormName, this.conditionFields)
          .subscribe(data => {
            this.input.nativeElement.value = data ? data[0]["description"] : "";
          })
      }

    }
  }
  // This has been moved to the LookupFieldService
  /* convertListToString(targetParameterList: []): string {
    let searchFields = "";
    if (targetParameterList.length > 0) {
      searchFields = targetParameterList.join(', ');
    }
    return searchFields;
  } */
  onFocusEvent(e) {
    // console.log({"Onfocus":e,"result":this.results$.subscribe(data => {console.log(data)})});
    console.log({ onFocusEventValue: e.value })
    if (e.value == "") {
      this.lookupFieldService.resetLookUp();
    }
  }
  /**
   * @comment 1. Calls lookUp function in OfbizFormService
   * 2. Lookup function calls the lookUpSearch function
   * 3. LookUpSearch sets the the lookUpSearchFields,lookUpEntity,and lookUpFormName parameters
   * 4. LookUpSearch function also sets lookUpQuerySubject with the value of the query
   * @param query used to search backend
   */
  lookUp(query): void {
    console.log({ DoWeGetHere: "lookUp" });
    if (query !== "" && query.length > 3) {
      console.log(query);
      this.lookupFieldService.lookUp(query, this.fieldName, this.entityName, this.searchFields, this.fieldFormName, this.conditionFields);
    }

  }
  selectLookUp(e) {
    console.log({ SelectLookUp: e });
    this.setLookupField.emit(e);
    this.lookupFieldService.isSelected();
    const selectedDisplayOption = this.lookupOptionList.find(option => option.id == e);
    if (selectedDisplayOption) {
      this.input.nativeElement.value = selectedDisplayOption.description
    }

    /* this.results$.subscribe(rows => {
      console.log({Rows:rows});
      let selected = rows.find(option => option.id == e);
      if(selected){
        this.input.nativeElement.value = selected.description
      }
    }) */
    /* this.results$.subscribe((options:any[]) => {
      console.log({Options:options});
      let selected = options.find(option => option.id == e);
      if(selected){
        this.input.nativeElement.value = selected.description
      }
    }) */
    /* console.log(e);
    console.log({TrackLookupField:e.target});
    console.log(e.target.tagName);
    let elem = this.handleClick(e.target);
    if(elem.tagName == "NB-OPTION"){
      this.input.nativeElement.value = elem.dataset.description;
      this.setLookupField.emit(elem.dataset.value);
      this.lookupFieldService.isSelected();
    } */
    /* this.results$.subscribe((options:any[]) => {
      let selected = options.find(option => option.id = )
    }) */

  }

  viewHandle(value: string) {
    return value.toUpperCase();
  }
  /**
   * @comment 1. Event to open a lookup dialog wrapped in the LookupDialogContainerComponent
   * 2. Looked up value is used to populate the requesting field (this lookup field)
   * 3. Data is emitted to parent component which is normally the OfbizFormComponent.
   * 4. Data maybe emitted from the parent component to a view component from where the dialog is opened
   * @param data consist of the properties for the field
   */
  openLookupDialog(data) {
    console.log({ TrackDialog: { component: "LookupFieldComponent", data: data } });
    this.openLookupDialogEvent.emit(this.formField);
  }

  handleClick(target: HTMLElement) {

    let liElement: HTMLElement | null = target;

    while (liElement && !(liElement.tagName === "NB-OPTION")) {

      liElement = liElement.parentElement;

    }

    // console.log( "FOUND .bar !!" );
    return liElement;

  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }


}
